<template>
  <div class="cita" style="margin-top:90px;">
    <v-container>
      <v-row>
        <v-col cols="12" class="text-center">
          <div class="pt-8 pb-8">
            <span class="d-block subtitles pb-6">Obtén una cita</span>

            <span class="d-block titles">Agenda una cita para saber más sobre tu caso.</span>
          </div>
        </v-col>
      </v-row>

      <v-row justify="center">
        <v-col cols="10" md="7">
          <v-form ref="form" lazy-validation v-model="valid">
            <v-row justify="center">
              <v-col cols="auto" class="text-center">
                <span class="subtitles d-block">Asunto</span>

                <v-select
                  menu-props="auto"
                  v-model="e1"
                  hide-details
                  style="width: 350px; border: 1px solid white;"
                  :items="items"
                  :hint="`${select.service}`"
                  return-object
                  label="Outlined style"
                  solo
                  id="select"
                  color="#fffff"
                  class="my-8 uppercase"
                ></v-select>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12">
                <span class="subtitles">Información del contacto</span>
              </v-col>

              <v-col cols="12">
                <v-text-field label="Nombre" v-model="name" :rules="nameRules"></v-text-field>
              </v-col>

              <v-col cols="12">
                <v-text-field label="Teléfono" v-model="phone" :rules="phoneRules"></v-text-field>
              </v-col>

              <v-col cols="12">
                <v-text-field label="Correo" v-model="email" :rules="emailRules"></v-text-field>
              </v-col>

              <v-col cols="12">
                <v-text-field label="¿Cómo te podemos ayudar?" v-model="message"></v-text-field>
              </v-col>
            </v-row>

            <v-row justify="center">
              <v-col cols="auto" class="text-center">
                <div>
                  <span class="subtitles">Fechas disponibles para agendar</span>
                </div>

                <div class="mt-6">
                  <v-date-picker
                    v-model="date"
                    v-bind:show-current="false"
                    v-bind:allowed-dates="allowedDates"
                    v-bind:min="minDate"
                    @update:picker-date="pickerUpdate($event)"
                    locale="es-mx"
                    header-color="#9D9D9C"
                    color="#9D9D9C"
                  ></v-date-picker>

                  <template v-if="dateError != ''">
                    <div class="v-messages theme--light error--text" role="alert">
                      <div class="v-messages__wrapper">
                        <div class="v-messages__message">{{dateError}}</div>
                      </div>
                    </div>
                  </template>
                </div>
              </v-col>
            </v-row>

            <v-row justify="center">
              <v-col cols="auto" class="text-center">
                <div>
                  <span class="subtitles">Seleccionar horario</span>
                </div>

                <div class="mt-6">
                  <v-select
                    v-model="e2"
                    menu-props="auto"
                    hide-details
                    :items="itemsSchedule"
                    label="Outlined style"
                    solo
                    id="select"
                    style="width: 350px; border: 1px solid white;"
                    color="white"
                    :rules="scheduleRules"
                  ></v-select>
                </div>
              </v-col>
            </v-row>

            <v-row>
              <!-- <v-col cols="12" class="text-center">
                <v-row justify="center">
                  <v-col cols="auto" class="align-self-center">
                    <v-checkbox v-model="terms" id="terms" :ripple="false" :rules="termsRules"></v-checkbox>
                  </v-col>
                  <v-col cols="auto" class="align-self-center">
                    <label
                      class="cursor-pointer"
                      style="text-decoration: underline;"
                      for="terms"
                    >Aceptar el aviso de privacidad</label>
                  </v-col>
                </v-row>
              </v-col>-->

              <v-col cols="12" class="text-center">
                <v-row>
                  <v-col cols="12">
                    <span
                      class="d-block"
                    >Verificar fecha y hora dos días antes de su cita, queda obstante a cambios.</span>

                    <span class="d-block">
                      Cualquier duda llamar.
                      Tel. 81.8342.2000
                    </span>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>

            <v-row class="pb-10">
              <v-col class="text-center">
                <v-btn
                  elevation="0"
                  :disabled="!valid"
                  width="250"
                  color="#B40000"
                  style="text-transform: none;"
                  @click="validate()"
                >
                  <span class="white--text">Enviar</span>
                </v-btn>
              </v-col>
            </v-row>
          </v-form>
        </v-col>
      </v-row>

      <!-- *********************inicia alerta de mensaje enviado************* -->
      <v-snackbar v-model="send" :timeout="timeSend" id="snackbarSend" color="black">
        <span>{{text}}</span>

        <v-btn color="white" text @click="send = false" :ripple="false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-snackbar>
      <!-- *********************termina alerta de mensaje enviado************* -->
    </v-container>
  </div>
</template>

<script>
import Vue from "vue";
import VueMoment from "vue-moment";
import moment from "moment-timezone";
Vue.use(VueMoment, {
  moment,
});

export default {
  data: () => ({
    //form
    valid: true,

    //Message send 'snackbar'
    send: false,
    text: "",
    timeSend: 12000,

    //items subject
    e1: "",
    items: ["otro"],
    select: { service: "sfs" },

    //schedule selection
    itemsSchedule: [
      "10:00 A.M",
      "11:00 A.M",
      "12:00 P.M",
      "4:00 P.M",
      "5:00 P.M",
      "6:00 P.M",
    ],
    e2: "10:00 A.M",
    // date: moment().format("YYYY-MM-DD"),
    date: "",
    dateError: "",
    minDate: moment().format("YYYY-MM-DD"),
    scheduleRules: [(v) => !!v || "Campo requerido"],
    availableDates: [],

    //form textfields and rules
    name: "",
    nameRules: [
      (v) => !!v || "Campo requerido",
      (v) => /^[a-zA-Z-áéíóúÁÉÍÓÚ\s]+$/.test(v) || "Solo se permiten letras",
    ],
    phone: "",
    phoneRules: [
      (v) => !!v || "Campo requerido",
      (v) => /^[0-9]+$/.test(v) || "Teléfono no válido",
    ],
    email: "",
    emailRules: [
      (v) => !!v || "Campo requerido",
      (v) => /.+@.+\..+/.test(v) || "Email no válido",
    ],
    message: "",
    terms: "",
    termsRules: [(v) => !!v || "Campo requerido"],
  }),
  beforeMount() {
    var aux = this;

    //traer el servicio
    fetch(
      "https://www.mlcpcms.actstudio.xyz/api/collections/get/servicios?token=16db21f0656450d15b7ee93d559638"
    )
      .then((res) => res.json())
      .then(function (res) {
        //set the TituloDeServicio to the v-model select
        if (aux.$route.params.servicio) {
          res.entries.forEach((service) => {
            if (
              service.urlService == aux.$route.params.servicio &&
              (service.urlService == aux.$route.params.servicio) == true
            ) {
              aux.e1 = service.TituloDeServicio;
            }
          });
        } else {
          aux.e1 = res.entries[0].TituloDeServicio;
        }

        //set all the services to the select
        for (let index = 0; index < res.entries.length; index++) {
          const element = res.entries[index];
          // console.log(element.position);
          aux.items.push(element.TituloDeServicio);
        }
      })
      .catch((error) => console.log(error.message));
  },
  mounted() {
    this.$emit("update", 1);
  },
  methods: {
    validate() {
      if (this.$refs.form.validate()) {
        if (this.date != "") {
          //activate toast
          this.send = true;
          this.text =
            "Tu solicitud de cita ha sido enviada, en breve nos pondremos en contacto para agendar la reunión.";
          this.dateError = "";

          //object with info to send
          var form_date = {
            Asunto: this.e1,
            Nombre: this.name,
            Teléfono: this.phone,
            Correo: this.email,
            Mensaje: this.message,
            Fecha: this.date + " " + "a las: " + this.e2,
          };

          console.log(form_date);

          //fetch to sent the form
          fetch('https://www.mlcpcms.actstudio.xyz/api/forms/submit/date?token=16db21f0656450d15b7ee93d559638', {
            method: "post",
            headers: {"Content-Type" : "application/json"},
            body: JSON.stringify({
              form: form_date
            })
          })

          .then(entry => entry.json())
          .then(entry => console.log(entry));

          // reset the textfields value
          this.$refs.form.reset();
        } else {
          this.dateError = "Porfavor selecciona una fecha.";
        }
      }
    },
    allowedDates(e) {
      return this.availableDates.includes(e);
    },
    pickerUpdate: function (val) {
      //get the value of calendar
      // console.log(val);
      let totalDay = moment(val, "YYYY-MM").daysInMonth();

      let availableDates = [];

      let monthNow = moment().format("M");
      let monthSelected = moment(val).format("M");
      let day;

      // console.log(monthNow);
      // console.log(monthSelected);
      if (monthNow == monthSelected) {
        day = moment().format("D");
        // console.log(day);
      } else {
        day = 1;
      }

      for (let i = day; i <= totalDay; i++) {
        let date = moment()
          .month(val.split("-")[1] - 1)
          .date(i)
          .format("YYYY-MM-DD");

        // console.log(moment()
        // .month(val.split("-")[1] - 1).date(i));

        if (
          date !== moment().format('YYYY-MM-DD') &&
          moment(date).day() !== 0 &&
          moment(date).day() !== 1 &&
          moment(date).day() !== 5 &&
          moment(date).day() !== 6 &&
          moment(date).day() !== 7
        ) {
          availableDates.push(date);
        }
      }

      this.availableDates = availableDates;
      this.allowedDates();
    },
  },
};
</script>